var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOrders(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.8927 4H7.5215C5.19073 4 3.30127 5.93998 3.30127 8.33307V9.70898H2.45455C1.65122 9.70898 1 10.3602 1 11.1635V11.4058C1 12.0177 1.37785 12.5413 1.91296 12.7561L3.02007 17.8713C3.38219 19.5445 4.86226 20.7384 6.57414 20.7384H13.6531C11.9018 19.574 10.7476 17.5829 10.7476 15.3221C10.7476 12.9284 12.0416 10.8369 13.9683 9.70898H12.5918H7.82771H4.83529V8.33321C4.83529 6.81034 6.03767 5.5758 7.52089 5.5758H12.8921L13.0394 5.57988C14.4541 5.65843 15.5777 6.8611 15.5777 8.33321V9.03893C16.069 8.90871 16.5832 8.83461 17.1129 8.82387V8.33307C17.1129 5.93998 15.2235 4 12.8927 4ZM12.7649 14.4726C13.1799 14.0416 13.8656 14.0286 14.2966 14.4435L16.29 16.3626L20.1569 12.5517C20.5831 12.1317 21.2689 12.1367 21.6889 12.5629C22.1088 12.989 22.1038 13.6748 21.6777 14.0948L17.0592 18.6463C16.641 19.0585 15.9705 19.0624 15.5475 18.6552L12.794 16.0043C12.363 15.5893 12.35 14.9036 12.7649 14.4726Z",
    fill: "#D5DAE0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrders);
export default __webpack_public_path__ + "static/media/orders.944fa046742f6a8177a1ac3a70cb651d.svg";
export { ForwardRef as ReactComponent };